import {CREATE_NOTIFICATION_REQUEST} from './actionTypes'

export const createNotification = (data) =>({
    type : CREATE_NOTIFICATION_REQUEST,
    payload : data
})
